import React from "react";
import { classNames } from "../../utils";
import Icon from "./Icon";
import propTypes from "prop-types";
import { useTemplateSetting } from "../../hooks/useCompanySettings";
import { TOOL_TEMPLATE } from "../../constant/common";

/**
 *
 * @param {{
 *    status: 1 | -1 | 0
 * }} param0
 * @returns
 */
const PriceUpDown = ({ status, children }) => {
  // const template = useTemplateSetting();
  const iconClass =
    status > 0
      ? "indicator-up"
      : status < 0
      ? "indicator-down"
      : "indicator-neutral";
  return <span className={classNames("data-values", iconClass)}>{children}</span>;
};

PriceUpDown.propTypes = {
  status: propTypes.oneOf([1, -1, 0]),
};

export default PriceUpDown;
